import { useNavigation } from "@react-navigation/native";
import React from "react";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";

import { FormattedMessage } from "react-intl";
import styles from "./style";

const WalletTransactionButtons = () => {
  const navigation = useNavigation();

  return (
    <View style={styles.containerBtns}>
      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("DepositMethod")}
          style={styles.card}
        >
          <Text style={styles.textCard}>
            <FormattedMessage id="cardsHome.depositar" />
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("WithdrawMethod")}
          style={styles.card}
        >
          <Text style={styles.textCard}>
            <FormattedMessage id="cardsHome.sacar" />
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("Transfer")}
          style={styles.card}
        >
          <Text style={styles.textCard}>
            <FormattedMessage id="cardsHome.transferir" />
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default WalletTransactionButtons;
